import { render, staticRenderFns } from "./PlayerNoticeList.vue?vue&type=template&id=d68cf016&"
import script from "./PlayerNoticeList.vue?vue&type=script&lang=js&"
export * from "./PlayerNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports